export default "/dist/files/informations_vide.aefea5e2d5f96a1a7c0a2f42dca6e590.svg";